/**
 * DO NOT ADD ANYTHING HERE!!!
 * THIS FILE HAS BEEN DEPRECATED IN ODER OF
 * AuthRedux AND NONE OF LOGIC HERE SHOULD CHANGE.
 *
 * TODO: Move everything into AuthRedux.
 */

import { userActionTypes } from "action-creators/user";
import { setCookie } from "cookies-next";
import { COMMONGROUND_SESSION } from "../configs/constants";

const INITIAL_STATE = {
  token: undefined,
  refreshToken: undefined,
  type: undefined,
  user: {},
  orgs: [],
};

export const UserSelectors = {
  token: (state) => state.user.token,
};

const UserState = (state = INITIAL_STATE, action) => {
  let newState = {};
  switch (action.type) {
    case userActionTypes.ON_LOGIN_SUCCESS:
      const loginData = action.data || {};
      newState = {
        ...state,
        user: loginData.user || {},
        type: loginData.type,
        token: loginData.token,
        expires: loginData.expires,
        refreshToken: loginData.refreshToken,
      };
      setCookie(COMMONGROUND_SESSION.token, loginData.token);
      setCookie(COMMONGROUND_SESSION.refreshToken, loginData.refreshToken);
      break;
    case userActionTypes.SET_USER:
      newState = {
        ...state,
        user: action.user,
      };
      break;
    case userActionTypes.ON_RECEIVED_TOKEN:
      newState = {
        ...state,
        token: action.data.token,
      };
      setCookie(COMMONGROUND_SESSION.token, action.data.token);
      break;
    case userActionTypes.SET_USER_ORGANIZATION:
      newState = {
        ...state,
        orgs: action.orgs,
      };
      break;
    case userActionTypes.SET_CURRENT_WORKING_ORGANIZATION:
      newState = {
        ...state,
        currentOrg: action.currentOrg,
      };
      break;
    case userActionTypes.SET_LAST_STEP_COMPLETED:
      newState = {
        ...state,
        user: {
          ...state.user,
          profile: {
            ...state.user.profile,
            last_step_complete: action.lastStep,
          },
        },
      };
      break;
    case userActionTypes.SET_TYPEFORM_RESPONSE_ID:
      newState = {
        ...state,
        user: {
          ...state.user,
          typeform_response_id: action.typeformResponseId,
        },
      };
      break;
      case userActionTypes.SET_USER_PROFILE:
        newState = {
          ...state,
          user: {
            ...state.user,
            profile: action.profile,
          },
        };
        break;
    default:
      return state;
  }
  return newState;
};
export default UserState;
